export const resolveDiagramSvgHeight = (heightProp, diagramOnly, diagramOnlyHeight, withKeyHeight) => {
  if (heightProp === "auto") return undefined;
  if (heightProp === "100%") return "100%";
  return heightProp ?? (diagramOnly ? diagramOnlyHeight : withKeyHeight);
};
